export default class ECSLeadUtils {
  // Collect and parse the URL parameters, check for active
  getUrlParams () {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    return urlParams
  }

  runAttributionAjax (_provider, _action, _data = false) {
    var result = null
    // Run the AJAX Action through WP
    $.ajaxSetup({ async: false })
    $.post(ecs_attribution_ajax_obj.ajax_url, {
      _ajax_nonce: ecs_attribution_ajax_obj.nonce,
      action: "ecs_" + _action + "_" + _provider,
      data: _data
    }, function (data) {
      result = data
    })
    $.ajaxSetup({ async: true })

    return result
  }
}
